/* istanbul ignore file */
export { default, PureHeader } from './Header';
